// extracted by mini-css-extract-plugin
export var content = "TextAndCta-module--content--rY97Q";
export var cta = "TextAndCta-module--cta--UzsFD";
export var image = "TextAndCta-module--image--DiG8m";
export var light = "TextAndCta-module--light--JDVkW";
export var wrapper = "TextAndCta-module--wrapper--uR35s";